module.exports = __webpack_public_path__ + "static/media/walking-independently-bw.a73b200d.jpg";